import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=8cbdaea4&scoped=true"
import script from "./contact.ts?vue&type=script&lang=ts&external"
export * from "./contact.ts?vue&type=script&lang=ts&external"
import style0 from "./Contact.vue?vue&type=style&index=0&id=8cbdaea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbdaea4",
  null
  
)

export default component.exports